import { atomFamily } from "recoil";

export const selectedLocationAtomFamily = atomFamily<string | undefined | null, string | undefined>({
  key: "selectedLocationAtomFamily",
  default: undefined,
});
